import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { BHRHoliday } from "@onsip/common/interfaces/bhr";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "onsip-holiday-list-view",
  templateUrl: "./holiday-list-view.component.html",
  styleUrls: ["../sayso-topic-view.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HolidayViewComponent {
  @Input() holidays: Array<BHRHoliday> = [];

  holidayMonths: Array<string> = [
    this.translate.instant("ONSIP_I18N.JANUARY"),
    this.translate.instant("ONSIP_I18N.FEBRUARY"),
    this.translate.instant("ONSIP_I18N.MARCH"),
    this.translate.instant("ONSIP_I18N.APRIL"),
    this.translate.instant("ONSIP_I18N.MAY"),
    this.translate.instant("ONSIP_I18N.JUNE"),
    this.translate.instant("ONSIP_I18N.JULY"),
    this.translate.instant("ONSIP_I18N.AUGUST"),
    this.translate.instant("ONSIP_I18N.SEPTEMBER"),
    this.translate.instant("ONSIP_I18N.OCTOBER"),
    this.translate.instant("ONSIP_I18N.NOVEMBER"),
    this.translate.instant("ONSIP_I18N.DECEMBER")
  ];

  constructor(private translate: TranslateService) {}
}
